// export const BASE_URL: string = "http://[2a00:6d42:1242:1c00::38f]:3000/";
export const BASE_URL: string = "https://api.spheery.com/";
export const APPLICATION_JSON: string = "application/json";
